<!-- EnvironmentDebug.svelte -->
<script>
  import { onMount } from 'svelte';
  import { getConfig, getEnvironment, isDevelopment } from '$lib/config/environment.js';
  
  let config = {};
  let environment = '';
  let showDebug = false;
  
  onMount(() => {
    environment = getEnvironment();
    config = getConfig();
    showDebug = isDevelopment();
  });
</script>

{#if showDebug}
  <div class="environment-debug">
    <details>
      <summary>🔧 Environment Debug ({environment})</summary>
      <div class="debug-content">
        <h4>Environment: {config.name}</h4>
        <div class="config-section">
          <h5>GrowthBook:</h5>
          <p>API Host: {config.growthbook?.apiHost}</p>
          <p>Client Key: {config.growthbook?.clientKey?.substring(0, 10)}...</p>
          <p>Dev Mode: {config.growthbook?.enableDevMode}</p>
          <p>Timeout: {config.growthbook?.timeout}ms</p>
        </div>
        <div class="config-section">
          <h5>API:</h5>
          <p>Base URL: {config.api?.baseUrl}</p>
        </div>
        <div class="config-section">
          <h5>Features:</h5>
          <p>Logging: {config.features?.enableLogging}</p>
          <p>Analytics: {config.features?.enableAnalytics}</p>
          <p>Hotjar: {config.features?.enableHotjar}</p>
        </div>
      </div>
    </details>
  </div>
{/if}

<style>
  .environment-debug {
    position: fixed;
    bottom: 10px;
    right: 10px;
    background: rgba(0, 0, 0, 0.9);
    color: white;
    padding: 15px;
    border-radius: 8px;
    font-size: 12px;
    z-index: 9999;
    max-width: 350px;
    max-height: 400px;
    overflow-y: auto;
    border: 1px solid #333;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
  
  summary {
    cursor: pointer;
    font-weight: bold;
    padding: 5px 0;
    border-bottom: 1px solid #333;
    margin-bottom: 10px;
  }
  
  summary:hover {
    color: #4ade80;
  }
  
  .debug-content {
    margin-top: 10px;
  }
  
  .config-section {
    margin-bottom: 15px;
    padding: 10px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }
  
  h4 {
    color: #4ade80;
    margin-bottom: 10px;
    font-size: 14px;
  }
  
  h5 {
    color: #fbbf24;
    margin-bottom: 5px;
    font-size: 12px;
  }
  
  p {
    margin: 3px 0;
    color: #e5e5e5;
    font-family: monospace;
  }
</style>
